/* React Higher Order Component which passes page visibility information to children
    child will receive props: {
        documentVisible: PropTypes.bool
    }
*/

import React from 'react';
import PropTypes from 'prop-types';

import VisibilityUtil from '../../util/VisibilityUtil';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {};

const defaultProps = {};

export default function withDocumentVisible(WrappedComponent) {
    class WithDocumentVisible extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                documentVisible: true
            };

            this.onDocumentVisible = this.onDocumentVisible.bind(this);
            this.onDocumentHidden = this.onDocumentHidden.bind(this);
        }

        UNSAFE_componentWillMount() {
            this.vUtil = new VisibilityUtil(this.onDocumentVisible, this.onDocumentHidden);
        }

        componentWillUnmount() {
            this.vUtil.removeListener();
            delete this.vUtil;
        }

        onDocumentVisible() {
            this.setState({ documentVisible: true });
        }
        
        onDocumentHidden() {
            this.setState({ documentVisible: false });
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    documentVisible={this.state.documentVisible}
                />
            );
        }
    }

    WithDocumentVisible.propTypes = propTypes;
    WithDocumentVisible.defaultProps = defaultProps;
    WithDocumentVisible.displayName = `WithDocumentVisible(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithDocumentVisible;
}
